export default __webpack_public_path__ + "fd22190.png";